var map = {
	"./calculator.png": 160,
	"./chess_game.png": 161,
	"./ellee_bakery.png": 162,
	"./hockey_finder.png": 163,
	"./itunes_search.png": 164,
	"./presto_assistant.png": 165
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 159;